import React, { useEffect } from "react";

export const KendoGrid = ({
  name,
  url,
  data,
  schema,
  columns,
  serverPaging,
  serverFiltering,
  serverSorting,
  filterable,
  sortable,
  paggable,
  scrollable,
  height,
  disableToolbar,
  exportFileName,
  showOptions,
  width,
  groupable,
  onEditClick,
  onDeleteClick,
  showEdit,
  showDelete,
  onDataBound,
  refreshWhen,
  disableExportExcel,
  optionWidth,
  enableRowReorderable,
  onRowReorder,
  showSearch = true,
  showApprovalBtn = false,
  onApprovalBtnClick,
}) => {
  const getFormattedDateTime = () => {
    const now = new Date();
    return (
      now.getFullYear() +
      "-" +
      ("0" + (now.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + now.getDate()).slice(-2) +
      "_" +
      ("0" + now.getHours()).slice(-2) +
      "-" +
      ("0" + now.getMinutes()).slice(-2) +
      "-" +
      ("0" + now.getSeconds()).slice(-2)
    );
  };
  useEffect(() => {
    //kenod grid options
    if (showOptions || false) {
      var Id = columns[0].field;
      var options = {
        template: function (e) {
          let approval =
            showApprovalBtn == false
              ? ""
              : `<a href="javascript:void(0);" id="k-grd-${name}-approval-${e[Id]}" title="Edit"><i class="k-icon k-i-check-circle k-grid-edit m-2" ></i></a>`;
          let edit =
            showEdit == false
              ? ""
              : `<a href="javascript:void(0);" id="k-grd-${name}-edit-${e[Id]}" title="Edit"><i class="k-icon k-i-pencil k-grid-edit m-2" ></i></a>`;
          let del =
            showDelete == false
              ? ""
              : `<a href="javascript:void(0);" id="k-grd-${name}-delete-${e[Id]}" title="Delete"><i class="k-icon k-i-trash k-grid-delete m-2"></i></a>`;
          return `<div style="text-align:center">
           ${approval} ${edit} ${del}
            </div>`;
        },
        title: showEdit && showDelete ? "Options" : "Option",

        width: optionWidth || "100px",
      };

      if (columns.find((e) => e.title == "Option") == null) {
        columns.push(options);
      }
    }

    let toolBar = [
      {
        name: "excel",
        template: `
    <button class="k-button k-grid-excel btn-excel">
      <span class="k-icon k-i-file-excel"></span>
    </button>
  `,
      },
      // "search",
      ...(showSearch ? ["search"] : []),
    ];
    if (disableExportExcel) {
      toolBar.splice(0, 1);
    }

    let kgrid1 = $(`#${name}`).data("kendoGrid");
    if (kgrid1) {
      kgrid1.destroy();
      $(`#${name}`).empty();
    }
    $(`#${name}`).kendoGrid({
      dataSource: {
        transport: url && {
          read: url,
        },
        data: !url && (data || []),
        schema: {
          model: {
            fields: schema,
          },
        },
        pageSize: 10,
        serverPaging: serverPaging || false,
        serverFiltering: serverFiltering || false,
        serverSorting: serverSorting || false,
      },
      width: width || "auto",
      height: height && height,
      scrollable: scrollable || true,
      filterable: filterable || false,
      sortable: sortable || true,
      // noRecords: {
      //   template: "No data available",
      // },
      toolbar: !disableToolbar && toolBar,
      reorderable: {
        rows: enableRowReorderable,
      },
      rowReorder: function (e) {
        if (enableRowReorderable && onRowReorder) {
          let pId = $(e.row).find("td:first").text();
          let grd = $(`#${name}`).data("kendoGrid");
          let newRow = grd.items().eq(e.oldIndex);
          let oldRow = grd.items().eq(e.newIndex);

          onRowReorder({
            pid: pId,
            oldIndex: e.oldIndex,
            oldRow: oldRow,
            newIndex: e.newIndex,
            newRow: newRow,
          });
        }
      },
      excel: {
        fileName: `${exportFileName}_${getFormattedDateTime()}`,
        proxyURL: "https://demos.telerik.com/kendo-ui/service/export",
        filterable: false,
        paggable: false,
        allPages: true,
      },
      pageable: !(paggable == false) && {
        pageSizes: [5, 10, 50, 100],
        buttonCount: 5,
      },
      columns: columns,
      dataBound: function (e) {
        const grid = this;
        const columns = grid.columns;
        if (this.dataSource.view().length === 0) {
          const emptyRowHtml = `<tr><td colspan="${columns.length}" style="text-align:center;">No data available</td></tr>`;
          $(`#${name} .k-grid-content tbody`).html(emptyRowHtml);
        } else {
          if (showOptions) {
            grid.dataSource.data().forEach(function (dataItem) {
              $(`#k-grd-${name}-approval-${dataItem[Id]}`).on(
                "click",
                function () {
                  onApprovalBtnClick(dataItem);
                }
              );
              $(`#k-grd-${name}-edit-${dataItem[Id]}`).on("click", function () {
                onEditClick(dataItem);
              });

              $(`#k-grd-${name}-delete-${dataItem[Id]}`).on(
                "click",
                function () {
                  onDeleteClick(dataItem);
                }
              );
            });
          }
        }

        if (onDataBound) {
          onDataBound();
        }
        if (scrollable || true) {
        }
      },
    });
  }, [data, refreshWhen]);

  return <div id={name}></div>;
};

export const RefreshKendoGrid = (name) => {
  let kgrid = $(`#${name}`).data("kendoGrid");
  if (kgrid) {
    kgrid.dataSource.read();
  }
};
